import { ArchiveDetailsArgs, ArchiveDetailsQuery, RepoItem } from '../../autogenerated/ZoomBridge';

class ArchiveDetails_Query {
  _fuid: Array<Number> = [];

  constructor(assets: Array<RepoItem>) {
    this._fuid = this.fetchFuidsFromArrayRepoItems(assets);
  }

  setFuids(fuids: Array<RepoItem>) {
    this._fuid = fuids;
  }

  getFuid() {
    return this._fuid;
  }

  fetchFuidsFromArrayRepoItems(assets: Array<RepoItem>) {
    const fuids: Array<Number> = [];
    assets.forEach((asset: RepoItem) => fuids.push(asset.getFuid()));
    return fuids;
  }

  fetchArchiveDetails(): Promise<any> {
    const archiveDetailsMsg: ArchiveDetailsArgs = new ArchiveDetailsArgs();
    const archiveDetailsQuery: ArchiveDetailsQuery = new ArchiveDetailsQuery();
    archiveDetailsMsg.setFuids(this.getFuid());
    archiveDetailsQuery.message = archiveDetailsMsg;
    return new Promise((resolve, reject) => {
      archiveDetailsQuery
        .run()
        .then(resolve)
        .catch(reject);
    });
  }
}

export default ArchiveDetails_Query;
